// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d49c0125","186":"10e0413b","272":"2a067ed4","372":"273d046f","443":"69f7154b","738":"d5120f5c","787":"891ee697","841":"2e54afa0","851":"58055603","856":"42101571"}[chunkId] + ".chunk.js";
};